(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('styled-components')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'styled-components'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['wfsc-ui-core'] = {}, global.React, global.PropTypes, global.StyledComponents));
}(this, (function (exports, React, PropTypes, styled) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
  var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  /**
   * COLOR
   */
  var COLORS = {
    /**
     * upper-case
     */
    DARK: '#333333',
    LIGHT: '#f6f6f6',
    GREY: '#dddddd',
    GREY_HOVER: '#cccccc',
    GREY_ACTIVE: '#666666',
    GREY_TEXT: '#999999',
    PRIMARY: 'orange',
    PRIMARY_HOVER: 'darkorange',
    SECONDARY: 'skyblue',
    SECONDARY_HOVER: 'deepskyblue',

    /**
     * lower camel case
     */
    dark: '#333333',
    light: '#f6f6f6',
    grey: '#dddddd',
    greyHover: '#cccccc',
    greyActive: '#666666',
    greyText: '#999999',
    primary: 'orange',
    primaryHover: 'darkorange',
    secondary: 'skyblue',
    secondaryHover: 'deepskyblue'
  };
  var SPACINGS = {
    /**
     * upper-case
     */
    XXS: '5px',
    XS: '10px',
    S: '20px',
    M: '30px',
    L: '50px',
    XL: '80px',
    XXL: '130px',

    /**
     * lower camel case
     */
    xxs: '5px',
    xs: '10px',
    s: '20px',
    m: '30px',
    l: '50px',
    xl: '80px',
    xxl: '130px'
  };

  var StyledBlock = styled__default['default'].div(function (_ref) {
    var display = _ref.display,
        justify = _ref.justify,
        justifyContent = _ref.justifyContent,
        alignItems = _ref.alignItems,
        boxSizing = _ref.boxSizing,
        width = _ref.width,
        minWidth = _ref.minWidth,
        maxWidth = _ref.maxWidth,
        height = _ref.height,
        minHeight = _ref.minHeight,
        maxHeight = _ref.maxHeight,
        overflow = _ref.overflow,
        margin = _ref.margin,
        marginTop = _ref.marginTop,
        marginLeft = _ref.marginLeft,
        marginRight = _ref.marginRight,
        marginBottom = _ref.marginBottom,
        padding = _ref.padding,
        paddingTop = _ref.paddingTop,
        paddingLeft = _ref.paddingLeft,
        paddingRight = _ref.paddingRight,
        paddingBottom = _ref.paddingBottom,
        background = _ref.background,
        boxShadow = _ref.boxShadow,
        border = _ref.border,
        borderTop = _ref.borderTop,
        borderLeft = _ref.borderLeft,
        borderRight = _ref.borderRight,
        borderBottom = _ref.borderBottom,
        borderRadius = _ref.borderRadius,
        position = _ref.position,
        top = _ref.top,
        left = _ref.left,
        right = _ref.right,
        bottom = _ref.bottom,
        zIndex = _ref.zIndex,
        customTheme = _ref.customTheme,
        dev = _ref.dev;

    var style = _objectSpread2({
      display: justify || justifyContent || alignItems ? 'flex' : display,
      justifyContent: justify || justifyContent,
      alignItems: alignItems,
      boxSizing: boxSizing,
      width: width,
      minWidth: minWidth,
      maxWidth: maxWidth,
      height: height,
      minHeight: minHeight,
      maxHeight: maxHeight,
      overflow: overflow,
      margin: SPACINGS[margin] || margin,
      marginTop: SPACINGS[marginTop] || marginTop,
      marginLeft: SPACINGS[marginLeft] || marginLeft,
      marginRight: SPACINGS[marginRight] || marginRight,
      marginBottom: SPACINGS[marginBottom] || marginBottom,
      padding: SPACINGS[padding] || padding,
      paddingTop: SPACINGS[paddingTop] || paddingTop,
      paddingLeft: SPACINGS[paddingLeft] || paddingLeft,
      paddingRight: SPACINGS[paddingRight] || paddingRight,
      paddingBottom: SPACINGS[paddingBottom] || paddingBottom,
      background: COLORS[background] || background,
      boxShadow: boxShadow,
      border: dev ? "1px dashed ".concat(COLORS.PRIMARY) : border,
      borderTop: borderTop,
      borderLeft: borderLeft,
      borderRight: borderRight,
      borderBottom: borderBottom,
      borderRadius: borderRadius,
      position: position,
      top: top,
      left: left,
      right: right,
      bottom: bottom,
      zIndex: zIndex
    }, customTheme.root);

    return style;
  });
  var StyledDevWrapper = styled__default['default'].div({
    boxSizing: 'border-box',
    border: "1px dashed ".concat(COLORS.SECONDARY)
  });

  var Block = function Block(props) {
    var style = props.style,
        theme = props.theme,
        className = props.className,
        dev = props.dev,
        children = props.children;

    var styledSettings = _objectSpread2(_objectSpread2({}, props), {}, {
      customTheme: theme
    });

    delete styledSettings.style;
    delete styledSettings.theme;
    delete styledSettings.className;
    delete styledSettings.children;
    return /*#__PURE__*/React__default['default'].createElement(StyledBlock, _extends({}, styledSettings, {
      style: style,
      className: className
    }), dev ? /*#__PURE__*/React__default['default'].createElement(StyledDevWrapper, null, children) : children);
  };

  Block.propTypes = {
    display: PropTypes__default['default'].string,
    justifyContent: PropTypes__default['default'].string,

    /**
     * alias of justifyContent
     */
    justify: PropTypes__default['default'].string,
    alignItems: PropTypes__default['default'].string,
    boxSizing: PropTypes__default['default'].string,
    width: PropTypes__default['default'].string,
    minWidth: PropTypes__default['default'].string,
    maxWidth: PropTypes__default['default'].string,
    height: PropTypes__default['default'].string,
    minHeight: PropTypes__default['default'].string,
    maxHeight: PropTypes__default['default'].string,
    overflow: PropTypes__default['default'].string,
    margin: PropTypes__default['default'].string,
    marginTop: PropTypes__default['default'].string,
    marginLeft: PropTypes__default['default'].string,
    marginRight: PropTypes__default['default'].string,
    marginBottom: PropTypes__default['default'].string,
    padding: PropTypes__default['default'].string,
    paddingTop: PropTypes__default['default'].string,
    paddingLeft: PropTypes__default['default'].string,
    paddingRight: PropTypes__default['default'].string,
    paddingBottom: PropTypes__default['default'].string,
    background: PropTypes__default['default'].string,
    boxShadow: PropTypes__default['default'].any,
    border: PropTypes__default['default'].string,
    borderTop: PropTypes__default['default'].string,
    borderLeft: PropTypes__default['default'].string,
    borderRight: PropTypes__default['default'].string,
    borderBottom: PropTypes__default['default'].string,
    borderRadius: PropTypes__default['default'].string,
    position: PropTypes__default['default'].string,
    top: PropTypes__default['default'].any,
    left: PropTypes__default['default'].any,
    right: PropTypes__default['default'].any,
    bottom: PropTypes__default['default'].any,
    zIndex: PropTypes__default['default'].any,
    style: PropTypes__default['default'].object,
    theme: PropTypes__default['default'].object,
    className: PropTypes__default['default'].string,
    dev: PropTypes__default['default'].bool,
    children: PropTypes__default['default'].any
  };
  Block.defaultProps = {
    display: null,
    justifyContent: null,
    justify: null,
    alignItems: null,
    boxSizing: 'border-box',
    width: null,
    minWidth: null,
    maxWidth: null,
    height: null,
    minHeight: null,
    maxHeight: null,
    overflow: null,
    margin: null,
    marginTop: null,
    marginLeft: null,
    marginRight: null,
    marginBottom: null,
    padding: null,
    paddingTop: null,
    paddingLeft: null,
    paddingRight: null,
    paddingBottom: null,
    background: null,
    boxShadow: null,
    border: null,
    borderTop: null,
    borderLeft: null,
    borderRight: null,
    borderBottom: null,
    borderRadius: null,
    position: null,
    top: null,
    left: null,
    right: null,
    bottom: null,
    zIndex: null,
    style: null,
    theme: {},
    className: null,
    dev: false,
    children: null
  };

  var repo_config = {
    defaultPrefix: 'wfsc'
  };
  var repo_config_1 = repo_config.defaultPrefix;

  var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
  };

  function isNonNullObject(value) {
    return !!value && typeof value === 'object';
  }

  function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
  } // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


  var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
  var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

  function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
  }

  function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
  }

  function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
  }

  function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function (element) {
      return cloneUnlessOtherwiseSpecified(element, options);
    });
  }

  function getMergeFunction(key, options) {
    if (!options.customMerge) {
      return deepmerge;
    }

    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : deepmerge;
  }

  function getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
      return target.propertyIsEnumerable(symbol);
    }) : [];
  }

  function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
  }

  function propertyIsOnObject(object, property) {
    try {
      return property in object;
    } catch (_) {
      return false;
    }
  } // Protects from prototype poisoning and unexpected merging up the prototype chain.


  function propertyIsUnsafe(target, key) {
    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
    && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
    && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
  }

  function mergeObject(target, source, options) {
    var destination = {};

    if (options.isMergeableObject(target)) {
      getKeys(target).forEach(function (key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
      });
    }

    getKeys(source).forEach(function (key) {
      if (propertyIsUnsafe(target, key)) {
        return;
      }

      if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
        destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
      } else {
        destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
      }
    });
    return destination;
  }

  function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject; // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.

    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
      return cloneUnlessOtherwiseSpecified(source, options);
    } else if (sourceIsArray) {
      return options.arrayMerge(target, source, options);
    } else {
      return mergeObject(target, source, options);
    }
  }

  deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) {
      throw new Error('first argument should be an array');
    }

    return array.reduce(function (prev, next) {
      return deepmerge(prev, next, options);
    }, {});
  };

  var deepmerge_1 = deepmerge;
  var cjs = deepmerge_1;

  /* xeslint-disable */
  var ThemeUtil = /*#__PURE__*/function () {
    function ThemeUtil() {
      _classCallCheck(this, ThemeUtil);
    }

    _createClass(ThemeUtil, null, [{
      key: "getSpacings",
      value: function getSpacings() {
        return {
          xxs: '5px',
          xs: '10px',
          s: '20px',
          m: '30px',
          l: '50px',
          xl: '80px',
          xxl: '130px'
        };
      }
    }, {
      key: "getColors",
      value: function getColors() {
        return {
          dark: '#333333',
          light: '#f6f6f6',
          grey: '#dddddd',
          greyHover: '#cccccc',
          greyActive: '#666666',
          greyText: '#999999',
          primary: 'orange',
          primaryHover: 'darkorange',
          secondary: 'skyblue',
          secondaryHover: 'deepskyblue'
        };
      }
    }, {
      key: "getGridBreakpoints",
      value: function getGridBreakpoints() {
        return {
          cols: 0,
          colsXS: 480,
          colsS: 768,
          colsM: 1024,
          colsL: 1280,
          colsXL: 1440,
          colsXXL: 1920
        };
      }
    }, {
      key: "getCommonStyles",
      value: function getCommonStyles() {
        return {
          borderRadius: '3px',
          boxShadowDropdown: '0 1px 4px 0px rgba(0, 0, 0, 0.2)'
        };
      }
    }, {
      key: "getStylesTextMedium",
      value: function getStylesTextMedium() {
        return {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '16px',
          lineHeight: '22px'
        };
      }
    }, {
      key: "getStylesTextSmall",
      value: function getStylesTextSmall() {
        return {
          fontFamily: '"Source Sans Pro", sans-serif',
          fontSize: '14px',
          lineHeight: '20px'
        };
      }
    }]);

    return ThemeUtil;
  }();

  var colors = ThemeUtil.getColors();
  var commonStyles = ThemeUtil.getCommonStyles();
  var stylesTextMedium = ThemeUtil.getStylesTextMedium();
  var stylesTextSmall = ThemeUtil.getStylesTextSmall();

  var styleDefault = _objectSpread2(_objectSpread2({
    appearance: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    background: colors.grey,
    border: 0,
    margin: 0,
    padding: '10px 15px'
  }, stylesTextMedium), {}, {
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    span: {
      display: 'inline-flex',
      marginLeft: '7px',
      '&:first-of-type': {
        marginLeft: 0
      }
    },
    svg: {
      width: '22px',
      height: '22px',
      verticalAlign: 'top'
    },
    '&[data-size-small]': _objectSpread2(_objectSpread2({
      padding: '5px 12px'
    }, stylesTextSmall), {}, {
      span: {
        display: 'inline-flex',
        marginLeft: '5px',
        '&:first-of-type': {
          marginLeft: 0
        }
      },
      svg: {
        width: '18px',
        height: '18px',
        verticalAlign: 'top'
      }
    }),
    '&[data-block]': {
      display: 'flex',
      width: '100%'
    },
    '&[data-disabled]': {
      opacity: 0.5,
      cursor: 'default',
      pointerEvents: 'none'
    }
  });

  var themeLayoutPrimary = {
    background: colors.primary,
    '&:focus': {
      outline: 0,
      background: colors.dark,
      color: 'white'
    },
    '&:hover': {
      background: colors.primaryHover,
      color: colors.dark
    },
    '&:active': {
      background: colors.primary,
      color: colors.dark
    }
  };
  var themeLayoutSecondary = {
    background: colors.secondary,
    '&:focus': {
      outline: 0,
      background: colors.dark,
      color: 'white'
    },
    '&:hover': {
      background: colors.secondaryHover,
      color: colors.dark
    },
    '&:active': {
      background: colors.secondary,
      color: colors.dark
    }
  };
  var themeLayoutOutlined = {
    background: 'transparent',
    boxShadow: "inset 0px 0px 0px 1px ".concat(colors.grey),
    '&:focus': {
      outline: 0,
      background: colors.dark,
      color: 'white',
      boxShadow: 'none'
    },
    '&:hover': {
      background: colors.light,
      color: colors.dark,
      boxShadow: "inset 0px 0px 0px 1px ".concat(colors.greyHover)
    },
    '&:active': {
      background: 'transparent',
      color: colors.dark,
      boxShadow: "inset 0px 0px 0px 1px ".concat(colors.grey)
    }
  };
  var themeLayoutOption = {
    background: 'transparent',
    fontWeight: 400,
    '&[data-active]': {
      background: 'transparent',
      color: colors.primary,
      '&:hover': {
        background: colors.light,
        color: colors.primary
      },
      '&:active': {
        background: 'transparent',
        color: colors.primary
      }
    },
    '&:focus': {
      outline: 0,
      background: colors.dark,
      color: 'white'
    },
    '&:hover': {
      background: colors.light,
      color: colors.dark
    },
    '&:active': {
      background: 'transparent',
      color: colors.dark
    }
  };
  var themeLayoutDefault = {
    borderRadius: commonStyles.borderRadius,
    color: colors.dark,
    fontWeight: 600,
    textDecoration: 'none',
    textAlign: 'left',
    '&:focus': {
      outline: 0,
      background: colors.dark,
      color: 'white'
    },
    '&:hover': {
      background: colors.greyHover,
      color: colors.dark
    },
    '&:active': {
      background: colors.grey,
      color: colors.dark
    },
    '&[data-with-icon]': {
      padding: '10px 15px 10px 12px'
    },
    '&[data-with-icon-right]': {
      padding: '10px 12px 10px 15px'
    },
    '&[data-with-icon-only]': {
      padding: '10px'
    },
    '&[data-size-small]': {
      '&[data-with-icon]': {
        padding: '5px 12px 5px 9px'
      },
      '&[data-with-icon-right]': {
        padding: '5px 9px 5px 12px'
      },
      '&[data-with-icon-only]': {
        padding: '6px'
      }
    },
    '&[data-layout-primary]': themeLayoutPrimary,
    '&[data-layout-secondary]': themeLayoutSecondary,
    '&[data-layout-outlined]': themeLayoutOutlined,
    '&[data-layout-option]': themeLayoutOption,
    '&[data-active]': {
      background: colors.greyActive,
      color: 'white',
      boxShadow: 'none',
      '&:focus': {
        outline: 0,
        background: colors.dark,
        color: 'white'
      },
      '&:hover': {
        background: colors.dark,
        color: 'white',
        boxShadow: 'none'
      },
      '&:active': {
        background: colors.greyActive,
        color: 'white',
        boxShadow: 'none'
      }
    }
  };
  var StyledButton = styled__default['default'].button(function (props) {
    var justify = props.justify,
        customTheme = props.customTheme;

    var style = _objectSpread2({}, styleDefault);

    if (justify) {
      style.justifyContent = justify;
    }

    if (customTheme.root) {
      style = cjs(style, customTheme.root);
    } else {
      style = cjs(style, themeLayoutDefault);
    }

    return style;
  });

  var Button = function Button(props) {
    var layout = props.layout,
        size = props.size,
        type = props.type,
        label = props.label,
        href = props.href,
        target = props.target,
        title = props.title,
        disabled = props.disabled,
        icon = props.icon,
        iconRight = props.iconRight,
        block = props.block,
        justify = props.justify,
        active = props.active,
        ariaLabel = props.ariaLabel,
        className = props.className,
        style = props.style,
        theme = props.theme,
        stopPropagation = props.stopPropagation,
        onClick = props.onClick;

    var handleOnClick = function handleOnClick(e) {
      if (href && disabled) {
        e.preventDefault();
      }

      if (stopPropagation) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }

      if (!disabled) {
        onClick(e);
      }
    };

    var handleOnMouseLeave = function handleOnMouseLeave(e) {
      e.currentTarget.blur();
    };
    /**
     * data
     */


    var data = {};

    if (active) {
      data['data-active'] = true;
    }

    if (disabled) {
      data['data-disabled'] = true;
    }

    var withIcon = Boolean(label && icon);

    if (withIcon) {
      data['data-with-icon'] = true;
    }

    var withIconRight = Boolean(label && iconRight);

    if (withIconRight) {
      data['data-with-icon-right'] = true;
    }

    var withIconOnly = Boolean(!label && icon);

    if (withIconOnly) {
      data['data-with-icon-only'] = true;
    }

    if (size) {
      data["data-size-".concat(size)] = true;
    }

    if (layout) {
      data["data-layout-".concat(layout)] = true;
    }

    if (block) {
      data['data-block'] = true;
    }
    /**
     * settings
     */


    var settings = {};

    if (href) {
      settings.as = 'a';
      settings.href = href;
      settings.target = target;
    } else {
      settings.type = type;
    }

    if (title) {
      settings.title = title;
    }

    if (ariaLabel) {
      settings['aria-label'] = ariaLabel;
    }

    if (style) {
      settings.style = style;
    }

    return /*#__PURE__*/React__default['default'].createElement(StyledButton, _extends({
      disabled: disabled,
      justify: justify,
      className: className,
      onClick: handleOnClick,
      onMouseLeave: handleOnMouseLeave,
      customTheme: theme
    }, settings, data), icon && /*#__PURE__*/React__default['default'].createElement("span", {
      className: "".concat(className, "__icon")
    }, icon), label && /*#__PURE__*/React__default['default'].createElement("span", {
      className: "".concat(className, "__label")
    }, label), iconRight && /*#__PURE__*/React__default['default'].createElement("span", {
      className: "".concat(className, "__icon-right")
    }, iconRight));
  };

  Button.propTypes = {
    /**
     * '', 'primary', 'secondary', 'outlined'
     */
    layout: PropTypes__default['default'].string,

    /**
     * '', 'small'
     */
    size: PropTypes__default['default'].string,
    type: PropTypes__default['default'].string,
    label: PropTypes__default['default'].string,
    href: PropTypes__default['default'].string,
    target: PropTypes__default['default'].string,
    title: PropTypes__default['default'].string,
    active: PropTypes__default['default'].bool,
    disabled: PropTypes__default['default'].bool,
    icon: PropTypes__default['default'].any,
    iconRight: PropTypes__default['default'].any,
    block: PropTypes__default['default'].bool,
    justify: PropTypes__default['default'].oneOf(['flex-start', 'flex-end', 'center', 'space-between']),
    ariaLabel: PropTypes__default['default'].string,
    stopPropagation: PropTypes__default['default'].bool,
    onClick: PropTypes__default['default'].func,
    className: PropTypes__default['default'].string,
    style: PropTypes__default['default'].object,
    theme: PropTypes__default['default'].object
  };
  Button.defaultProps = {
    layout: '',
    size: '',
    type: 'button',
    label: '',
    href: '',
    target: '',
    title: '',
    active: false,
    disabled: false,
    icon: null,
    iconRight: null,
    block: false,
    justify: 'center',
    ariaLabel: '',
    stopPropagation: false,
    onClick: function onClick() {},
    className: "".concat(repo_config_1, "-button"),
    style: null,
    theme: {}
  };

  /* xeslint-disable */
  var spacings = ThemeUtil.getSpacings();
  var StyledGroupItem = styled__default['default'].div(function (props) {
    var spacing = props.spacing,
        hSpacing = props.hSpacing,
        vSpacing = props.vSpacing,
        justify = props.justify,
        grow = props.grow,
        width = props.width,
        vertical = props.vertical;
    var itemStyle = {};
    /**
     * spacing
     */

    if (spacings[spacing]) {
      itemStyle.paddingRight = spacings[spacing];
      itemStyle.paddingBottom = spacings[spacing];
    } else if (spacing) {
      itemStyle.paddingRight = spacing;
      itemStyle.paddingBottom = spacing;
    }

    if (spacings[hSpacing]) {
      itemStyle.paddingRight = spacings[hSpacing];
    } else if (hSpacing) {
      itemStyle.paddingRight = hSpacing;
    }

    if (spacings[vSpacing]) {
      itemStyle.paddingBottom = spacings[vSpacing];
    } else if (vSpacing) {
      itemStyle.paddingBottom = vSpacing;
    }
    /**
     * grow
     */


    if (!vertical && grow) {
      itemStyle.flexGrow = 1;
    }
    /**
     * justify space-evenly-start
     */


    if (!vertical && justify === 'space-evenly-start') {
      itemStyle.flex = '1 1 auto';
    }
    /**
     * width
     */


    if (width) {
      itemStyle.flexBasis = width;
      itemStyle.width = width;
    }

    return itemStyle;
  });

  var GroupItem = function GroupItem(props) {
    var children = props.children;
    return /*#__PURE__*/React__default['default'].createElement(StyledGroupItem, props, children);
  };

  GroupItem.displayName = 'GroupItem';
  GroupItem.propTypes = {
    spacing: PropTypes__default['default'].string,
    hSpacing: PropTypes__default['default'].string,
    vSpacing: PropTypes__default['default'].string,
    justify: PropTypes__default['default'].string,
    grow: PropTypes__default['default'].bool,
    width: PropTypes__default['default'].string,
    vertical: PropTypes__default['default'].bool,
    children: PropTypes__default['default'].any,
    className: PropTypes__default['default'].string
  };
  GroupItem.defaultProps = {
    spacing: '',
    hSpacing: '',
    vSpacing: '',
    justify: 'flex-start',
    grow: false,
    width: '',
    vertical: false,
    children: null,
    className: "".concat(repo_config_1, "-group__item")
  };

  var themeColors = ThemeUtil.getColors();
  var themeSpacings = ThemeUtil.getSpacings();

  var StyleModel = /*#__PURE__*/function () {
    function StyleModel(initialProps) {
      _classCallCheck(this, StyleModel);

      this._style = initialProps || {};
    }

    _createClass(StyleModel, [{
      key: "add",
      value: function add(props) {
        this._style = cjs(this._style, props);
      }
    }, {
      key: "addBackground",
      value: function addBackground(background) {
        if (background) {
          this._style.background = themeColors[background] || background;
        }
      }
    }, {
      key: "addSpacing",
      value: function addSpacing(key, value) {
        this._style[key] = themeSpacings[value] || value;
      }
    }, {
      key: "addPadding",
      value: function addPadding(paddingProps) {
        var _this = this;

        var keys = ['padding', 'paddingTop', 'paddingLeft', 'paddingRight', 'paddingBottom'];
        keys.forEach(function (key) {
          if (paddingProps[key]) {
            _this.addSpacing(key, paddingProps[key]);
          }
        });
      }
    }, {
      key: "style",
      get: function get() {
        return this._style;
      }
    }]);

    return StyleModel;
  }();

  var spacings$1 = ThemeUtil.getSpacings();
  var StyledWrapper = styled__default['default'].div(function (props) {
    var padding = props.padding,
        paddingTop = props.paddingTop,
        paddingLeft = props.paddingLeft,
        paddingRight = props.paddingRight,
        paddingBottom = props.paddingBottom,
        background = props.background;
    var styleModel = new StyleModel({
      display: 'flex',
      boxSizing: 'border-box'
    });
    /**
     * padding
     */

    styleModel.addPadding({
      padding: padding,
      paddingTop: paddingTop,
      paddingLeft: paddingLeft,
      paddingRight: paddingRight,
      paddingBottom: paddingBottom
    });
    /**
     * background
     */

    styleModel.addBackground(background);
    return styleModel.style;
  });
  var StyledGroup = styled__default['default'].div(function (_ref) {
    var spacing = _ref.spacing,
        hSpacing = _ref.hSpacing,
        vSpacing = _ref.vSpacing,
        justify = _ref.justify,
        alignItems = _ref.alignItems,
        nowrap = _ref.nowrap,
        vertical = _ref.vertical;
    var style = {
      flexGrow: 1,
      display: 'flex',
      flexFlow: 'row wrap'
    };
    /**
     * spacing
     */

    if (spacings$1[spacing]) {
      style.marginRight = "-".concat(spacings$1[spacing]);
      style.marginBottom = "-".concat(spacings$1[spacing]);
    } else if (spacing) {
      style.marginRight = "-".concat(spacing);
      style.marginBottom = "-".concat(spacing);
    }

    if (spacings$1[hSpacing]) {
      style.marginRight = "-".concat(spacings$1[hSpacing]);
    } else if (hSpacing) {
      style.marginRight = "-".concat(hSpacing);
    }

    if (spacings$1[vSpacing]) {
      style.marginBottom = "-".concat(spacings$1[vSpacing]);
    } else if (vSpacing) {
      style.marginBottom = "-".concat(vSpacing);
    }
    /**
     * nowrap
     */


    if (!vertical && nowrap) {
      style.flexFlow = 'row nowrap';
    }
    /**
     * vertical
     */


    if (vertical) {
      style.display = 'block';
    }
    /**
     * justify space-evenly-start
     */


    if (!vertical && justify === 'space-evenly-start') {
      style.justifyContent = 'space-between';
    }
    /**
     * justify
     */


    if (!vertical && !['space-evenly-start'].includes(justify)) {
      style.justifyContent = justify;
    }
    /**
     * alignItems
     */


    if (!vertical && alignItems) {
      style.alignItems = alignItems;
    }

    return style;
  });

  var Group = function Group(props) {
    var spacing = props.spacing,
        hSpacing = props.hSpacing,
        vSpacing = props.vSpacing,
        justify = props.justify,
        grow = props.grow,
        vertical = props.vertical,
        className = props.className,
        children = props.children;
    var aChildren = React__default['default'].Children.toArray(children);

    var settings = _objectSpread2({}, props);

    delete settings.className;
    delete settings.children;
    return /*#__PURE__*/React__default['default'].createElement(StyledWrapper, _extends({}, settings, {
      className: className
    }), /*#__PURE__*/React__default['default'].createElement(StyledGroup, settings, aChildren.map(function (child, i) {
      if (!child) {
        return false;
      }

      var childSettings = {
        spacing: spacing,
        hSpacing: hSpacing,
        vSpacing: vSpacing,
        justify: justify,
        grow: grow,
        vertical: vertical,
        className: "".concat(className, "__item")
      };

      if (child.type.displayName === 'GroupItem') {
        return /*#__PURE__*/React__default['default'].cloneElement(child, _objectSpread2(_objectSpread2({
          key: String(i)
        }, childSettings), {}, {
          grow: child.props.grow || grow
        }));
      }

      return /*#__PURE__*/React__default['default'].createElement(GroupItem, _extends({
        key: String(i)
      }, childSettings), child);
    })));
  };

  Group.propTypes = {
    /**
     * '' | [spacing] | [custom CSS]
     */
    spacing: PropTypes__default['default'].string,
    hSpacing: PropTypes__default['default'].string,
    vSpacing: PropTypes__default['default'].string,

    /**
     * '' | [flex justify-content]
     */
    justify: PropTypes__default['default'].string,

    /**
     * '' | [flex align-items]
     */
    alignItems: PropTypes__default['default'].string,
    grow: PropTypes__default['default'].bool,
    nowrap: PropTypes__default['default'].bool,
    vertical: PropTypes__default['default'].bool,

    /**
     * '' | [spacing] | [custom CSS]
     */
    padding: PropTypes__default['default'].string,

    /**
     * '' | [spacing] | [custom CSS]
     */
    paddingTop: PropTypes__default['default'].string,

    /**
     * '' | [spacing] | [custom CSS]
     */
    paddingLeft: PropTypes__default['default'].string,

    /**
     * '' | [spacing] | [custom CSS]
     */
    paddingRight: PropTypes__default['default'].string,

    /**
     * '' | [spacing] | [custom CSS]
     */
    paddingBottom: PropTypes__default['default'].string,

    /**
     * '' | 'dark' | 'light' | 'grey' | 'primary' | 'secondary' | [custom CSS]
     */
    background: PropTypes__default['default'].string,
    className: PropTypes__default['default'].string,
    children: PropTypes__default['default'].any
  };
  Group.defaultProps = {
    spacing: '',
    hSpacing: '',
    vSpacing: '',
    justify: '',
    alignItems: '',
    grow: false,
    nowrap: false,
    vertical: false,
    padding: '',
    paddingTop: '',
    paddingLeft: '',
    paddingRight: '',
    paddingBottom: '',
    background: '',
    className: "".concat(repo_config_1, "-group"),
    children: null
  };

  var Check = /*#__PURE__*/React__default['default'].createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "currentColor",
    d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
  }));

  var stylesTextMedium$1 = ThemeUtil.getStylesTextMedium();
  var colors$1 = ThemeUtil.getColors();
  var StyledRoot = styled__default['default'].div({
    position: 'relative',
    '&[data-disabled]': {
      opacity: 0.5,
      pointerEvents: 'none'
    }
  });
  var StyledCheckbox = styled__default['default'].div(function (_ref) {
    var customTheme = _ref.customTheme;
    var style = {
      flex: '0 0 auto',
      width: '22px',
      height: '22px',
      border: "1px solid ".concat(colors$1.greyText),
      boxSizing: 'border-box',
      background: 'white',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      svg: {
        width: '18px',
        height: '18px',
        opacity: 0
      },
      '&[data-checked]': {
        svg: {
          opacity: 1
        }
      }
    };

    if (customTheme.checkbox) {
      style = cjs(style, customTheme.checkbox);
    } else {
      style = cjs(style, {
        color: colors$1.dark,
        '&[data-focus]': {
          borderColor: colors$1.dark
        },
        '&[data-checked]': {
          svg: {
            color: colors$1.primary
          }
        }
      });
    }

    return style;
  });
  var StyledLabel = styled__default['default'].span(function (_ref2) {
    var customTheme = _ref2.customTheme;

    var style = _objectSpread2({
      display: 'inline-block'
    }, stylesTextMedium$1);

    if (customTheme.label) {
      style = cjs(style, customTheme.label);
    }

    return style;
  });
  var StyledInput = styled__default['default'].input({
    appearance: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    height: 0,
    width: 0,
    margin: 0,
    padding: 0,
    fontSize: 0,
    lineHeight: 0,
    opacity: 0
  });

  var Checkbox = function Checkbox(_ref3) {
    var id = _ref3.id,
        name = _ref3.name,
        value = _ref3.value,
        label = _ref3.label,
        ariaLabel = _ref3.ariaLabel,
        checked = _ref3.checked,
        disabled = _ref3.disabled,
        spacing = _ref3.spacing,
        icon = _ref3.icon,
        onChange = _ref3.onChange,
        className = _ref3.className,
        theme = _ref3.theme;

    var _useState = React.useState(checked),
        _useState2 = _slicedToArray(_useState, 2),
        isChecked = _useState2[0],
        setIsChecked = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isFocus = _useState4[0],
        setIsFocus = _useState4[1];

    var refInput = React.useRef();
    React.useEffect(function () {
      setIsChecked(checked);
    }, [checked]);

    var handleOnInputChange = function handleOnInputChange(e) {
      setIsChecked(e.target.checked);
      onChange(e);
    };

    var handleOnClickCheckbox = function handleOnClickCheckbox() {
      if (refInput && refInput.current) {
        refInput.current.click();
        refInput.current.focus();
      }
    };

    var handleOnFocus = function handleOnFocus() {
      setIsFocus(true);
    };

    var handleOnBlur = function handleOnBlur() {
      setIsFocus(false);
    };

    var inputSettings = {};

    if (id) {
      inputSettings.id = id;
    }
    /**
     * data
     */


    var data = {};

    if (isFocus) {
      data['data-focus'] = true;
    }

    if (isChecked) {
      data['data-checked'] = true;
    }

    if (disabled) {
      data['data-disabled'] = true;
    }

    return /*#__PURE__*/React__default['default'].createElement(StyledRoot, _extends({
      className: className
    }, data), /*#__PURE__*/React__default['default'].createElement(StyledInput, _extends({
      ref: refInput,
      type: "checkbox",
      name: name,
      value: value,
      checked: isChecked,
      "aria-label": ariaLabel || label,
      disabled: disabled,
      onChange: handleOnInputChange,
      onFocus: handleOnFocus,
      onBlur: handleOnBlur
    }, inputSettings)), /*#__PURE__*/React__default['default'].createElement(Group, {
      nowrap: true,
      spacing: spacing
    }, /*#__PURE__*/React__default['default'].createElement(StyledCheckbox, _extends({
      isChecked: isChecked,
      onClick: handleOnClickCheckbox,
      className: "".concat(className, "__checkbox"),
      customTheme: theme
    }, data), icon || Check), label && /*#__PURE__*/React__default['default'].createElement(StyledLabel, _extends({
      className: "".concat(className, "__label"),
      customTheme: theme
    }, data), label)));
  };

  Checkbox.propTypes = {
    id: PropTypes__default['default'].string,
    name: PropTypes__default['default'].string,
    label: PropTypes__default['default'].string,
    ariaLabel: PropTypes__default['default'].string,
    value: PropTypes__default['default'].any,
    checked: PropTypes__default['default'].bool,
    disabled: PropTypes__default['default'].bool,
    icon: PropTypes__default['default'].any,
    spacing: PropTypes__default['default'].string,
    onChange: PropTypes__default['default'].func,
    className: PropTypes__default['default'].string,
    theme: PropTypes__default['default'].object
  };
  Checkbox.defaultProps = {
    id: '',
    label: '',
    ariaLabel: '',
    name: '',
    value: '',
    checked: false,
    disabled: false,
    icon: null,
    spacing: 'xs',
    onChange: function onChange() {},
    className: "".concat(repo_config_1, "-checkbox"),
    theme: {}
  };

  var Collapse = function Collapse(props) {
    var show = props.show,
        duration = props.duration,
        animationType = props.animationType,
        keepChildren = props.keepChildren,
        children = props.children;

    var _useState = React.useState(show),
        _useState2 = _slicedToArray(_useState, 2),
        isShown = _useState2[0],
        setIsShown = _useState2[1];

    var _useState3 = React.useState(keepChildren || isShown),
        _useState4 = _slicedToArray(_useState3, 2),
        renderContent = _useState4[0],
        setRenderContent = _useState4[1];

    var _useState5 = React.useState(show ? 'none' : 0),
        _useState6 = _slicedToArray(_useState5, 2),
        maxHeight = _useState6[0],
        setMaxHeight = _useState6[1];

    var _useState7 = React.useState(show ? 'visible' : 'hidden'),
        _useState8 = _slicedToArray(_useState7, 2),
        overflow = _useState8[0],
        setOverflow = _useState8[1];

    var _useState9 = React.useState(null),
        _useState10 = _slicedToArray(_useState9, 2),
        timeoutIdShow = _useState10[0],
        setTimeoutIdShow = _useState10[1];

    var _useState11 = React.useState(null),
        _useState12 = _slicedToArray(_useState11, 2),
        timeoutIdHide = _useState12[0],
        setTimeoutIdHide = _useState12[1];

    var refComponent = React.useRef();
    var refWrapper = React.useRef();
    React.useEffect(function () {
      if (typeof window !== 'undefined') {
        /**
         * get current dimensions
         */
        var componentHeight = refComponent.current.clientHeight;
        var wrapperHeight = refWrapper.current.clientHeight;
        /**
         * add content to dom before it is shown
         */

        if (!keepChildren && isShown && !renderContent) {
          setRenderContent(true);
        }
        /**
         * show content after content is rendered
         */


        if (isShown && renderContent) {
          /**
           * if content is initially shown
           */
          if (componentHeight === wrapperHeight) {
            setMaxHeight('none');
            setOverflow('visible');
          }
          /**
           * show content
           * if content is hidden or is going to be hidden
           */


          if (componentHeight !== wrapperHeight) {
            /**
             * animate
             */
            setMaxHeight("".concat(wrapperHeight, "px"));
            setOverflow('hidden');
            /**
             * after animation
             */

            setTimeoutIdShow(window.setTimeout(function () {
              setMaxHeight('none');
              setOverflow('visible');
            }, duration));
          }
        }
        /**
         * hide content
         */


        if (!isShown) {
          /**
           * if content is completely hidden
           */
          if (componentHeight === 0) {
            setMaxHeight(0);
            setOverflow('hidden');
          }
          /**
           * if content is shown or is going to be shown
           */


          if (componentHeight > 0) {
            /**
             * first fix max height to animate via css
             */
            setMaxHeight("".concat(wrapperHeight, "px"));
            /**
             * animate
             * after a short delay for rendering
             */

            setTimeoutIdHide(window.setTimeout(function () {
              setMaxHeight(0);
              setOverflow('hidden');
              /**
               * remove content from dom
               */

              if (!keepChildren) {
                setTimeoutIdShow(window.setTimeout(function () {
                  setRenderContent(false);
                }, duration));
              }
            }, 50));
          }
        }
      }
    }, [isShown, renderContent, duration, keepChildren]);
    /**
     * fix for SSR:
     * use internal state isShown instead of property show
     */

    React.useEffect(function () {
      setIsShown(show);
    }, [show]);
    /**
     * clear timeouts, so a current animation is stopped
     */

    React.useEffect(function () {
      return function cleanup() {
        window.clearTimeout(timeoutIdShow);
        window.clearTimeout(timeoutIdHide);
      };
    }, [timeoutIdShow, timeoutIdHide]);
    /**
     * set css inline styles
     */

    var style = {
      maxHeight: maxHeight,
      overflow: overflow,
      transition: "max-height ".concat(duration / 1000, "s ").concat(animationType)
    };
    return /*#__PURE__*/React__default['default'].createElement("div", {
      style: style,
      ref: refComponent
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      ref: refWrapper
    }, renderContent && children));
  };

  Collapse.propTypes = {
    show: PropTypes__default['default'].bool,

    /**
     * milliseconds
     */
    duration: PropTypes__default['default'].number,
    animationType: PropTypes__default['default'].string,
    keepChildren: PropTypes__default['default'].bool,
    children: PropTypes__default['default'].any
  };
  Collapse.defaultProps = {
    show: false,
    duration: 200,
    animationType: 'ease',
    keepChildren: true,
    children: null
  };

  /**
   * see: https://medium.com/@eymaslive/react-hooks-useobserve-use-resizeobserver-custom-hook-45ec95ad9844
   */

  var useResizeObserver = function useResizeObserver(_ref) {
    var disabled = _ref.disabled,
        element = _ref.element,
        onResize = _ref.onResize;
    var current = element && element.current;
    var observer = React.useRef(null);
    React.useEffect(function () {
      if (!disabled) {
        var observe = function observe() {
          if (element && element.current && observer.current) {
            observer.current.observe(element.current);
          }
        }; // if we are already observing old element


        if (observer && observer.current && current) {
          observer.current.unobserve(current);
        } // TODO: use ployfill sooner or later
        // const ResizeObserverOrPolyfill = ResizeObserver;
        // observer.current = new ResizeObserverOrPolyfill(callback);


        observer.current = new ResizeObserver(onResize);
        observe();
      }

      return function () {
        if (observer && observer.current && element && current) {
          observer.current.unobserve(current);
        }
      };
    }, [disabled, current, element, onResize]);
  };

  var StyledComponent = styled__default['default'].div({
    position: 'relative',
    paddingTop: '100%',
    overflow: 'hidden'
  });
  var StyledWrapper$1 = styled__default['default'].div({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  });
  var StyledImage = styled__default['default'].img({
    position: 'absolute',
    top: '-1000%',
    bottom: '-1000%',
    left: '-1000%',
    right: '-1000%',
    margin: 'auto',
    verticalAlign: 'top',
    width: '100%',
    height: '100%',
    opacity: 0,
    '&[data-loaded]': {
      opacity: 1
    }
  });

  var CroppedImage = function CroppedImage(props) {
    var src = props.src,
        srcWebP = props.srcWebP,
        alt = props.alt,
        ratio = props.ratio,
        width = props.width,
        height = props.height,
        background = props.background,
        imageTransition = props.imageTransition,
        onImageLoaded = props.onImageLoaded;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isImageLoaded = _useState2[0],
        setIsImageLoaded = _useState2[1];

    var _useState3 = React.useState(0),
        _useState4 = _slicedToArray(_useState3, 2),
        naturalWidth = _useState4[0],
        setNaturalWidth = _useState4[1];

    var _useState5 = React.useState(0),
        _useState6 = _slicedToArray(_useState5, 2),
        naturalHeight = _useState6[0],
        setNaturalHeight = _useState6[1];

    var _useState7 = React.useState(0),
        _useState8 = _slicedToArray(_useState7, 2),
        componentWidth = _useState8[0],
        setComponetWidth = _useState8[1];

    var _useState9 = React.useState(0),
        _useState10 = _slicedToArray(_useState9, 2),
        componentHeight = _useState10[0],
        setComponentHeight = _useState10[1];

    var wrapperRef = React.useRef();
    var imgRef = React.useRef();

    var _ratio = ratio || '1:1';

    var _ratio$split = _ratio.split(':'),
        _ratio$split2 = _slicedToArray(_ratio$split, 2),
        w = _ratio$split2[0],
        h = _ratio$split2[1];

    var ratioWidth = parseFloat(w) || 1;
    var ratioHeight = parseFloat(h) || 1;
    useResizeObserver({
      disabled: ratio !== null,
      element: wrapperRef,
      onResize: function onResize(resizeObserverEntries) {
        /**
         * only proceed if no ratio is given
         */
        if (!ratio) {
          var entry = resizeObserverEntries[0];

          if (entry) {
            var contentRect = entry.contentRect || {};
            setComponetWidth(contentRect.width);
            setComponentHeight(contentRect.height);
          }
        }
      }
    });

    var handleOnImageLoaded = function handleOnImageLoaded() {
      if (imgRef.current) {
        setNaturalWidth(imgRef.current.naturalWidth || 1);
        setNaturalHeight(imgRef.current.naturalHeight || 1);
      }

      setIsImageLoaded(true);
      onImageLoaded();
    };
    /**
     * component inline style
     */


    var componentStyle = {
      paddingTop: "".concat(100 / ratioWidth * ratioHeight, "%"),
      background: background
    };

    if (width) {
      componentStyle.width = width;
    }

    if (height) {
      componentStyle.height = height;
      componentStyle.paddingTop = 0;
    }

    if (width && !height && ratio) {
      componentStyle.paddingTop = "calc(".concat(width, " / ").concat(ratioWidth / ratioHeight, ")");
    }

    if (!width && height && ratio) {
      componentStyle.width = "calc(".concat(height, " * ").concat(ratioWidth / ratioHeight, ")");
    }
    /**
     * image inline style
     */


    var componentRatioFloat;

    if (ratio) {
      componentRatioFloat = ratioWidth / ratioHeight;
    } else if (componentWidth && componentHeight) {
      componentRatioFloat = componentWidth / componentHeight;
    } else if (wrapperRef.current) {
      componentRatioFloat = wrapperRef.current.offsetWidth / wrapperRef.current.offsetHeight;
    }

    var imageWidth;
    var imageHeight;

    if (componentRatioFloat > naturalWidth / naturalHeight) {
      imageWidth = '100%';
      imageHeight = 'auto';
    } else {
      imageWidth = 'auto';
      imageHeight = '100%';
    }

    var imageStyle = {
      width: imageWidth,
      height: imageHeight,
      transition: imageTransition
    };
    /**
     * data attributes
     */

    var data = {};

    if (isImageLoaded) {
      data['data-loaded'] = true;
    }

    var image = /*#__PURE__*/React__default['default'].createElement(StyledImage, _extends({
      ref: imgRef,
      src: src,
      alt: alt,
      onLoad: handleOnImageLoaded,
      style: imageStyle
    }, data));
    return /*#__PURE__*/React__default['default'].createElement(StyledComponent, _extends({
      style: componentStyle
    }, data), /*#__PURE__*/React__default['default'].createElement(StyledWrapper$1, {
      ref: wrapperRef
    }, src && srcWebP && /*#__PURE__*/React__default['default'].createElement("picture", null, /*#__PURE__*/React__default['default'].createElement("source", {
      srcSet: srcWebP,
      type: "image/webp"
    }), image), src && !srcWebP && image));
  };

  CroppedImage.propTypes = {
    src: PropTypes__default['default'].string,
    srcWebP: PropTypes__default['default'].string,
    alt: PropTypes__default['default'].string,
    ratio: PropTypes__default['default'].string,
    width: PropTypes__default['default'].string,
    height: PropTypes__default['default'].string,
    background: PropTypes__default['default'].string,
    imageTransition: PropTypes__default['default'].string,
    onImageLoaded: PropTypes__default['default'].func
  };
  CroppedImage.defaultProps = {
    src: '',
    srcWebP: '',
    alt: '',
    ratio: null,
    width: null,
    height: null,
    background: null,
    imageTransition: null,
    onImageLoaded: function onImageLoaded() {}
  };

  var ChevronUp = /*#__PURE__*/React__default['default'].createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "currentColor",
    d: "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
  }));

  var ChevronDown = /*#__PURE__*/React__default['default'].createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "currentColor",
    d: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
  }));

  var commonStyles$1 = ThemeUtil.getCommonStyles();
  var StyledDropdown = styled__default['default'].div(function (_ref) {
    var block = _ref.block,
        customTheme = _ref.customTheme;
    var style = {
      position: 'relative',
      display: 'inline-block'
    };

    if (block) {
      style.display = 'block';
    }

    if (customTheme.root) {
      style = cjs(style, customTheme.root);
    }

    return style;
  });
  var StyledMenuWrapper = styled__default['default'].div({
    position: 'relative',
    width: '100%',
    height: 0
  });
  var StyledMenu = styled__default['default'].div(function (props) {
    var customTheme = props.customTheme;
    var style = {
      position: 'absolute',
      zIndex: 10,
      top: 0,
      left: 0,
      minWidth: '100%',
      boxSizing: 'border-box',
      background: 'white',
      boxShadow: commonStyles$1.boxShadowDropdown
    };

    if (customTheme.menu) {
      style = cjs(style, customTheme.menu);
    } else {
      style = cjs(style, {
        padding: '5px',
        borderRadius: commonStyles$1.borderRadius
      });
    }

    return style;
  });

  var Dropdown = function Dropdown(props) {
    var layout = props.layout,
        label = props.label,
        block = props.block,
        iconOpen = props.iconOpen,
        iconClose = props.iconClose,
        disabled = props.disabled,
        show = props.show,
        children = props.children,
        onChange = props.onChange,
        className = props.className,
        theme = props.theme;

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isOpen = _useState2[0],
        setIsOpen = _useState2[1];

    var refComponent = React.useRef();
    /**
     * close dropdown on click outside
     */

    var handleOnClickDocument = function handleOnClickDocument(e) {
      if (!refComponent.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    /**
     * listen on document click
     * add listener on component did mount
     * remover listener on component will unmount
     */


    React.useEffect(function () {
      document.addEventListener('click', handleOnClickDocument);
      return function () {
        document.removeEventListener('click', handleOnClickDocument);
      };
    }, []);
    /**
     * callback on change
     */

    React.useEffect(function () {
      onChange(isOpen);
    }, [isOpen]);
    /**
     * show (remote via props)
     */

    React.useEffect(function () {
      setIsOpen(show);
    }, [show]);
    /**
     * handler
     */

    var handleOnClickButton = function handleOnClickButton() {
      setIsOpen(!isOpen);
    };
    /**
     * icons
     */


    var _iconOpen = iconOpen || ChevronDown;

    var _iconClose = iconClose || ChevronUp;

    return /*#__PURE__*/React__default['default'].createElement(StyledDropdown, {
      ref: refComponent,
      className: className,
      block: block,
      customTheme: theme
    }, /*#__PURE__*/React__default['default'].createElement(Button, {
      layout: layout,
      label: label,
      iconRight: isOpen ? _iconClose : _iconOpen,
      onClick: handleOnClickButton,
      block: block,
      justify: "space-between",
      disabled: disabled,
      theme: {
        root: theme.button
      }
    }), isOpen && /*#__PURE__*/React__default['default'].createElement(StyledMenuWrapper, null, /*#__PURE__*/React__default['default'].createElement(StyledMenu, {
      className: "".concat(className, "__menu"),
      customTheme: theme
    }, children)));
  };

  Dropdown.propTypes = {
    layout: PropTypes__default['default'].oneOf(['default', 'primary', 'secondary', 'outlined', '']),
    label: PropTypes__default['default'].string,
    block: PropTypes__default['default'].bool,
    iconOpen: PropTypes__default['default'].any,
    iconClose: PropTypes__default['default'].any,
    disabled: PropTypes__default['default'].bool,
    show: PropTypes__default['default'].bool,
    children: PropTypes__default['default'].any,
    onChange: PropTypes__default['default'].func,
    className: PropTypes__default['default'].string,
    theme: PropTypes__default['default'].object
  };
  Dropdown.defaultProps = {
    layout: '',
    label: '',
    block: false,
    iconOpen: null,
    iconClose: null,
    disabled: false,
    show: false,
    children: null,
    onChange: function onChange() {},
    className: "".concat(repo_config_1, "-dropdown"),
    theme: {}
  };

  var spacings$2 = ThemeUtil.getSpacings();
  var StyledGridItem = styled__default['default'].div(function (_ref) {
    var gridSpacing = _ref.gridSpacing,
        gridHSpacing = _ref.gridHSpacing,
        gridVSpacing = _ref.gridVSpacing,
        gridNowrap = _ref.gridNowrap,
        customTheme = _ref.customTheme;
    var style = {
      flexGrow: 0,
      flexShrink: 0,
      boxSizing: 'border-box'
    };
    /**
     * gridSpacing
     */

    if (spacings$2[gridSpacing]) {
      style.paddingRight = spacings$2[gridSpacing];
      style.paddingBottom = spacings$2[gridSpacing];
    } else if (gridSpacing) {
      style.paddingRight = gridSpacing;
      style.paddingBottom = gridSpacing;
    }

    if (spacings$2[gridHSpacing]) {
      style.paddingRight = spacings$2[gridHSpacing];
    } else if (gridHSpacing) {
      style.paddingRight = gridHSpacing;
    }

    if (spacings$2[gridVSpacing]) {
      style.paddingBottom = spacings$2[gridVSpacing];
    } else if (gridVSpacing) {
      style.paddingBottom = gridVSpacing;
    }
    /**
     * gridNowrap
     */


    if (gridNowrap) {
      style.paddingBottom = 0;
    }
    /**
     * custom theme
     */


    if (customTheme.root) {
      style = cjs(style, customTheme.root);
    }

    return style;
  });

  var GridItem = function GridItem(_ref2) {
    var grow = _ref2.grow,
        width = _ref2.width,
        gridSpacing = _ref2.gridSpacing,
        gridHSpacing = _ref2.gridHSpacing,
        gridVSpacing = _ref2.gridVSpacing,
        gridNowrap = _ref2.gridNowrap,
        children = _ref2.children,
        className = _ref2.className,
        theme = _ref2.theme;

    /**
     * styled props
     */
    var styledProps = {
      gridSpacing: gridSpacing,
      gridHSpacing: gridHSpacing,
      gridVSpacing: gridVSpacing,
      gridNowrap: gridNowrap,
      customTheme: theme
    };
    /**
     * inline styles
     */

    var style = {
      flexBasis: width,
      width: width,
      flexGrow: grow ? 1 : 0
    };
    return /*#__PURE__*/React__default['default'].createElement(StyledGridItem, _extends({}, styledProps, {
      style: style,
      className: className
    }), children);
  };

  GridItem.propTypes = {
    colspan: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),

    /**
     * alias of colspan
     */
    cols: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
    grow: PropTypes__default['default'].bool,
    width: PropTypes__default['default'].string,
    children: PropTypes__default['default'].any,
    className: PropTypes__default['default'].string,

    /**
     * value is inherited from Grid (spacing)
     */
    gridSpacing: PropTypes__default['default'].string,

    /**
     * value is inherited from Grid (spacing)
     */
    gridHSpacing: PropTypes__default['default'].string,

    /**
     * value is inherited from Grid (hSpacing)
     */
    gridVSpacing: PropTypes__default['default'].string,

    /**
     * value is inherited from Grid (vSpacing)
     */
    gridNowrap: PropTypes__default['default'].bool,

    /**
     * value is inherited from Grid (theme.item)
     */
    theme: PropTypes__default['default'].object
  };
  GridItem.defaultProps = {
    colspan: 0,
    cols: 0,
    grow: false,
    width: '',
    children: null,
    className: "".concat(repo_config_1, "-grid__item"),
    gridSpacing: '',
    gridHSpacing: '',
    gridVSpacing: '',
    gridNowrap: false,
    theme: {}
  };

  var spacings$3 = ThemeUtil.getSpacings();
  var StyledGrid = styled__default['default'].div(function (_ref) {
    var spacing = _ref.spacing,
        hSpacing = _ref.hSpacing,
        vSpacing = _ref.vSpacing,
        justifyContent = _ref.justifyContent,
        justify = _ref.justify,
        alignItems = _ref.alignItems,
        alignContent = _ref.alignContent,
        nowrap = _ref.nowrap,
        customTheme = _ref.customTheme;
    var style = {
      display: 'flex',
      flexFlow: 'row wrap'
    };
    /**
     * spacing
     */

    if (spacings$3[spacing]) {
      style.marginRight = "-".concat(spacings$3[spacing]);
      style.marginBottom = "-".concat(spacings$3[spacing]);
    } else if (spacing) {
      style.marginRight = "-".concat(spacing);
      style.marginBottom = "-".concat(spacing);
    }

    if (spacings$3[hSpacing]) {
      style.marginRight = "-".concat(spacings$3[hSpacing]);
    } else if (hSpacing) {
      style.marginRight = "-".concat(hSpacing);
    }

    if (spacings$3[vSpacing]) {
      style.marginBottom = "-".concat(spacings$3[vSpacing]);
    } else if (vSpacing) {
      style.marginBottom = "-".concat(vSpacing);
    }
    /**
     * justifyContent || justify
     */


    if (justifyContent || justify) {
      style.justifyContent = justifyContent || justify;
    }
    /**
     * alignItems
     */


    if (alignItems) {
      style.alignItems = alignItems;
    }
    /**
     * alignContent
     */


    if (alignContent) {
      style.alignContent = alignContent;
    }
    /**
     * nowrap
     */


    if (nowrap) {
      style.flexWrap = 'nowrap';
      style.marginBottom = 0;
    }
    /**
     * custom theme
     */


    if (customTheme.root) {
      style = cjs(style, customTheme.root);
    }

    return style;
  });

  var Grid = function Grid(_ref2) {
    var columns = _ref2.columns,
        spacing = _ref2.spacing,
        hSpacing = _ref2.hSpacing,
        vSpacing = _ref2.vSpacing,
        justifyContent = _ref2.justifyContent,
        justify = _ref2.justify,
        alignItems = _ref2.alignItems,
        alignContent = _ref2.alignContent,
        nowrap = _ref2.nowrap,
        children = _ref2.children,
        className = _ref2.className,
        theme = _ref2.theme;
    var aChildren = React__default['default'].Children.toArray(children);
    var inlineStyle = {};
    return /*#__PURE__*/React__default['default'].createElement(StyledGrid, {
      spacing: spacing,
      hSpacing: hSpacing,
      vSpacing: vSpacing,
      justifyContent: justifyContent,
      justify: justify,
      alignItems: alignItems,
      alignContent: alignContent,
      nowrap: nowrap,
      style: inlineStyle,
      className: className,
      customTheme: theme
    }, aChildren.map(function (child, i) {
      var childProps = _objectSpread2({}, child.props);
      /**
       * inherit spacing as gridSpacing
       */


      childProps.gridSpacing = spacing;
      childProps.gridHSpacing = hSpacing;
      childProps.gridVSpacing = vSpacing;
      /**
       * inherit nowrap as gridNowrap
       */

      childProps.gridNowrap = nowrap;
      /**
       * width / grow DEV
       */

      if (!childProps.width || childProps.width === 'auto') {
        if (childProps.grow) {
          childProps.width = '0%';
        } else {
          var colspan = childProps.cols || childProps.colspan || 1;
          childProps.width = "".concat(100 / parseFloat(columns) * parseFloat(colspan), "%");
        }
      }
      /**
       * className
       */


      childProps.className = "".concat(className, "__item");
      /**
       * merge inherited theme and local theme
       */

      childProps.theme = {
        root: cjs(theme.item || {}, childProps.theme.root || {})
      };
      return /*#__PURE__*/React__default['default'].createElement(GridItem, _extends({
        key: String(i)
      }, childProps));
    }));
  };

  Grid.propTypes = {
    columns: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
    spacing: PropTypes__default['default'].string,
    hSpacing: PropTypes__default['default'].string,
    vSpacing: PropTypes__default['default'].string,
    justifyContent: PropTypes__default['default'].string,

    /**
     * alias of justifyContent
     */
    justify: PropTypes__default['default'].string,
    alignItems: PropTypes__default['default'].string,
    alignContent: PropTypes__default['default'].string,
    nowrap: PropTypes__default['default'].bool,
    children: PropTypes__default['default'].any,
    className: PropTypes__default['default'].string,
    theme: PropTypes__default['default'].object
  };
  Grid.defaultProps = {
    columns: 12,
    spacing: '',
    hSpacing: '',
    vSpacing: '',
    justifyContent: '',
    justify: '',
    alignItems: '',
    alignContent: '',
    nowrap: false,
    children: null,
    className: "".concat(repo_config_1, "-grid"),
    theme: {}
  };

  var colors$2 = ThemeUtil.getColors();
  var commonStyles$2 = ThemeUtil.getCommonStyles();
  var stylesTextMedium$2 = ThemeUtil.getStylesTextMedium();
  var stylesTextSmall$1 = ThemeUtil.getStylesTextSmall();
  var StyledInput$1 = styled__default['default'].input(function (_ref) {
    var block = _ref.block,
        width = _ref.width,
        maxWidth = _ref.maxWidth,
        customTheme = _ref.customTheme,
        keepDefaultTheme = _ref.keepDefaultTheme;

    var style = _objectSpread2({
      appearance: 'none',
      boxSizing: 'border-box',
      border: "1px solid ".concat(colors$2.grey),
      boxShadow: 'none',
      background: 'white',
      color: colors$2.dark,
      padding: '10px 15px'
    }, stylesTextMedium$2);

    var themeDefault = {
      boxShadow: "inset 0px 0px 0px 1px ".concat(colors$2.grey),
      border: 0,
      borderRadius: commonStyles$2.borderRadius,
      '&::placeholder': {
        fontStyle: 'italic',
        color: colors$2.greyText
      },
      '&:hover': {
        boxShadow: "inset 0px 0px 0px 1px ".concat(colors$2.greyHover)
      },
      '&:focus': {
        outline: 0,
        boxShadow: "inset 0px 0px 0px 2px ".concat(colors$2.primary)
      },
      '&:disabled': {
        opacity: 0.5,
        cursor: 'default',
        pointerEvents: 'none'
      },
      '&[data-size-small]': _objectSpread2({
        padding: '5px 12px'
      }, stylesTextSmall$1)
    };

    if (block) {
      style.display = 'block';
      style.width = '100%';
    }

    if (width) {
      style.width = width;
    }

    if (maxWidth) {
      style.maxWidth = maxWidth;
    }

    if (customTheme.root) {
      if (keepDefaultTheme) {
        style = cjs(style, themeDefault);
      }

      style = cjs(style, customTheme.root);
    } else {
      style = cjs(style, themeDefault);
    }

    return style;
  });

  var Input = function Input(_ref2) {
    var id = _ref2.id,
        type = _ref2.type,
        value = _ref2.value,
        name = _ref2.name,
        placeholder = _ref2.placeholder,
        maxLength = _ref2.maxLength,
        ariaLabel = _ref2.ariaLabel,
        disabled = _ref2.disabled,
        autoComplete = _ref2.autoComplete,
        autoFocus = _ref2.autoFocus,
        block = _ref2.block,
        width = _ref2.width,
        maxWidth = _ref2.maxWidth,
        size = _ref2.size,
        inputRef = _ref2.inputRef,
        blurOnEnter = _ref2.blurOnEnter,
        className = _ref2.className,
        style = _ref2.style,
        theme = _ref2.theme,
        keepDefaultTheme = _ref2.keepDefaultTheme,
        onChange = _ref2.onChange,
        onFocus = _ref2.onFocus,
        onBlur = _ref2.onBlur,
        onKeyDown = _ref2.onKeyDown,
        onKeyUp = _ref2.onKeyUp,
        onEnter = _ref2.onEnter;
    var inputRefLocal = React.useRef();

    var _useState = React.useState(value),
        _useState2 = _slicedToArray(_useState, 2),
        valueLocal = _useState2[0],
        setValueLocal = _useState2[1];

    React.useEffect(function () {
      setValueLocal(value);
    }, [value]);

    var handleOnChange = function handleOnChange(e) {
      setValueLocal(e.target.value);
      onChange(e);
    };

    var handleOnKeyDown = function handleOnKeyDown(e) {
      onKeyDown({
        keyCode: e.keyCode
      });
    };

    var handleOnKeyUp = function handleOnKeyUp(e) {
      onKeyUp({
        keyCode: e.keyCode
      });
      /**
       * on press enter
       */

      if (e.keyCode === 13) {
        var ref = inputRef || inputRefLocal;

        if (blurOnEnter && ref.current) {
          ref.current.blur();
        }

        onEnter();
      }
    };

    var settings = {
      id: id,
      name: name,
      placeholder: placeholder,
      maxLength: maxLength,
      'aria-label': ariaLabel,
      autoComplete: autoComplete,
      block: block,
      width: width,
      maxWidth: maxWidth
    };

    if (autoFocus) {
      settings.autoFocus = autoFocus;
    }

    if (style) {
      settings.style = style;
    }
    /**
     * data
     */


    var data = {};

    if (size) {
      data["data-size-".concat(size.toLowerCase())] = true;
    }

    return /*#__PURE__*/React__default['default'].createElement(StyledInput$1, _extends({
      ref: inputRef || inputRefLocal,
      className: className,
      type: type,
      value: valueLocal,
      disabled: disabled,
      onChange: function onChange(e) {
        return handleOnChange(e);
      },
      onFocus: onFocus,
      onBlur: onBlur,
      onKeyDown: function onKeyDown(e) {
        return handleOnKeyDown(e);
      },
      onKeyUp: function onKeyUp(e) {
        return handleOnKeyUp(e);
      },
      customTheme: theme,
      keepDefaultTheme: keepDefaultTheme
    }, settings, data));
  };

  Input.propTypes = {
    id: PropTypes__default['default'].string,
    type: PropTypes__default['default'].string,
    value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),
    name: PropTypes__default['default'].string,
    placeholder: PropTypes__default['default'].string,
    maxLength: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),
    ariaLabel: PropTypes__default['default'].string,
    disabled: PropTypes__default['default'].bool,
    autoComplete: PropTypes__default['default'].string,
    autoFocus: PropTypes__default['default'].bool,
    block: PropTypes__default['default'].bool,
    width: PropTypes__default['default'].string,
    maxWidth: PropTypes__default['default'].string,
    size: PropTypes__default['default'].string,
    inputRef: PropTypes__default['default'].any,
    blurOnEnter: PropTypes__default['default'].bool,
    className: PropTypes__default['default'].string,
    style: PropTypes__default['default'].object,
    theme: PropTypes__default['default'].object,
    keepDefaultTheme: PropTypes__default['default'].bool,
    onChange: PropTypes__default['default'].func,
    onFocus: PropTypes__default['default'].func,
    onBlur: PropTypes__default['default'].func,
    onKeyDown: PropTypes__default['default'].func,
    onKeyUp: PropTypes__default['default'].func,
    onEnter: PropTypes__default['default'].func
  };
  Input.defaultProps = {
    id: null,
    type: 'text',
    value: '',
    name: null,
    placeholder: null,
    maxLength: null,
    ariaLabel: null,
    disabled: false,
    autoComplete: null,
    autoFocus: false,
    block: false,
    width: null,
    maxWidth: null,
    size: '',
    inputRef: null,
    blurOnEnter: false,
    className: "".concat(repo_config_1, "-input"),
    style: null,
    theme: {},
    keepDefaultTheme: false,
    onChange: function onChange() {},
    onFocus: function onFocus() {},
    onBlur: function onBlur() {},
    onKeyDown: function onKeyDown() {},
    onKeyUp: function onKeyUp() {},
    onEnter: function onEnter() {}
  };

  /* eslint-disable no-unused-vars */
  var colors$3 = ThemeUtil.getColors();
  var StyledWrapper$2 = styled__default['default'].span(function (_ref) {
    var width = _ref.width,
        height = _ref.height,
        color = _ref.color;
    var style = {
      display: 'inline-block',
      width: width,
      height: height,
      svg: {
        width: '100%',
        height: '100%',
        verticalAlign: 'top'
      }
    };

    if (color) {
      style.color = colors$3[color] || color;
    }

    return style;
  });

  var InlineSVG = function InlineSVG(props) {
    var children = props.children;
    return /*#__PURE__*/React__default['default'].createElement(StyledWrapper$2, props, children);
  };

  InlineSVG.propTypes = {
    width: PropTypes__default['default'].string,
    height: PropTypes__default['default'].string,
    color: PropTypes__default['default'].string,
    children: PropTypes__default['default'].any
  };
  InlineSVG.defaultProps = {
    width: '24px',
    height: 'auto',
    color: '',
    children: null
  };

  var Radio = function Radio(props) {
    var value = props.value,
        children = props.children,
        onChange = props.onChange,
        className = props.className,
        theme = props.theme;
    var aChildren = React__default['default'].Children.toArray(children);

    var _useState = React.useState(value),
        _useState2 = _slicedToArray(_useState, 2),
        selectedValue = _useState2[0],
        setSelectedValue = _useState2[1];

    React.useEffect(function () {
      setSelectedValue(value);
    }, [value]);

    var handleOnChangeRadio = function handleOnChangeRadio(e) {
      setSelectedValue(e.target.value);
      onChange(e.target.value);
    };

    var groupSettings = _objectSpread2({}, props);

    delete groupSettings.value;
    delete groupSettings.children;
    delete groupSettings.theme;
    return /*#__PURE__*/React__default['default'].createElement(Group, _extends({}, groupSettings, {
      className: className
    }), aChildren.map(function (child, i) {
      var childProps = _objectSpread2({}, child.props);

      return /*#__PURE__*/React__default['default'].cloneElement(child, {
        key: String(i),
        checked: childProps.value === selectedValue,
        theme: cjs(theme.item || {}, childProps.theme || {}),
        onChange: function onChange(e) {
          return handleOnChangeRadio(e);
        }
      });
    }));
  };

  Radio.propTypes = {
    value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),
    children: PropTypes__default['default'].any,
    onChange: PropTypes__default['default'].func,
    className: PropTypes__default['default'].string,
    theme: PropTypes__default['default'].object
  };
  Radio.defaultProps = {
    value: '',
    children: null,
    onChange: function onChange() {},
    className: "".concat(repo_config_1, "-radio-group"),
    theme: {}
  };

  var colors$4 = ThemeUtil.getColors();
  var stylesTextMedium$3 = ThemeUtil.getStylesTextMedium();
  var StyledRoot$1 = styled__default['default'].div({
    position: 'relative',
    '&[data-disabled]': {
      opacity: 0.5,
      pointerEvents: 'none'
    }
  });
  var StyledRadio = styled__default['default'].div(function (_ref) {
    var customTheme = _ref.customTheme;
    var style = {
      flex: '0 0 auto',
      width: '22px',
      height: '22px',
      border: "1px solid ".concat(colors$4.greyText),
      borderRadius: '50%',
      boxSizing: 'border-box',
      background: 'white',
      cursor: 'pointer',
      '&[data-checked]': {
        background: colors$4.dark,
        boxShadow: 'inset 0 0 0 5px white'
      }
    };

    if (customTheme.radio) {
      style = cjs(style, customTheme.radio);
    } else {
      style = cjs(style, {
        color: colors$4.dark,
        '&[data-focus]': {
          borderColor: colors$4.dark
        },
        '&[data-checked]': {
          background: colors$4.primary
        }
      });
    }

    return style;
  });
  var StyledInput$2 = styled__default['default'].input({
    appearance: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    height: 0,
    width: 0,
    margin: 0,
    padding: 0,
    fontSize: 0,
    lineHeight: 0,
    opacity: 0
  });
  var StyledLabel$1 = styled__default['default'].span(function (_ref2) {
    var customTheme = _ref2.customTheme;

    var style = _objectSpread2({
      display: 'inline-block'
    }, stylesTextMedium$3);

    if (customTheme.label) {
      style = cjs(style, customTheme.label);
    }

    return style;
  });

  var Radio$1 = function Radio(props) {
    var id = props.id,
        name = props.name,
        value = props.value,
        label = props.label,
        checked = props.checked,
        disabled = props.disabled,
        ariaLabel = props.ariaLabel,
        spacing = props.spacing,
        onChange = props.onChange,
        className = props.className,
        theme = props.theme;

    var _useState = React.useState(checked),
        _useState2 = _slicedToArray(_useState, 2),
        isChecked = _useState2[0],
        setIsChecked = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isFocus = _useState4[0],
        setIsFocus = _useState4[1];

    var refInput = React.useRef();
    React.useEffect(function () {
      setIsChecked(checked);
    }, [checked]);

    var handleOnInputChange = function handleOnInputChange(e) {
      setIsChecked(e.target.checked);
      onChange(e);
    };

    var handleOnClickRadio = function handleOnClickRadio() {
      if (refInput && refInput.current) {
        refInput.current.click();
        refInput.current.focus();
      }
    };

    var handleOnFocus = function handleOnFocus() {
      setIsFocus(true);
    };

    var handleOnBlur = function handleOnBlur() {
      setIsFocus(false);
    };

    var inputSettings = {};

    if (id) {
      inputSettings.id = id;
    }
    /**
     * data
     */


    var data = {};

    if (isFocus) {
      data['data-focus'] = true;
    }

    if (isChecked) {
      data['data-checked'] = true;
    }

    if (disabled) {
      data['data-disabled'] = true;
    }

    return /*#__PURE__*/React__default['default'].createElement(StyledRoot$1, _extends({
      className: className
    }, data), /*#__PURE__*/React__default['default'].createElement(StyledInput$2, _extends({
      ref: refInput,
      type: "radio",
      name: name,
      value: value,
      checked: isChecked,
      "aria-label": ariaLabel || label,
      disabled: disabled,
      onChange: handleOnInputChange,
      onFocus: handleOnFocus,
      onBlur: handleOnBlur
    }, inputSettings)), /*#__PURE__*/React__default['default'].createElement(Group, {
      nowrap: true,
      spacing: spacing
    }, /*#__PURE__*/React__default['default'].createElement(StyledRadio, _extends({
      isChecked: isChecked,
      onClick: handleOnClickRadio,
      className: "".concat(className, "__radio"),
      customTheme: theme
    }, data)), label && /*#__PURE__*/React__default['default'].createElement(StyledLabel$1, _extends({
      className: "".concat(className, "__label"),
      customTheme: theme
    }, data), label)));
  };

  Radio$1.propTypes = {
    id: PropTypes__default['default'].string,
    name: PropTypes__default['default'].string,
    label: PropTypes__default['default'].string,
    ariaLabel: PropTypes__default['default'].string,
    value: PropTypes__default['default'].any,
    checked: PropTypes__default['default'].bool,
    disabled: PropTypes__default['default'].bool,
    spacing: PropTypes__default['default'].string,
    onChange: PropTypes__default['default'].func,
    className: PropTypes__default['default'].string,
    theme: PropTypes__default['default'].object
  };
  Radio$1.defaultProps = {
    id: '',
    label: '',
    ariaLabel: '',
    name: '',
    value: '',
    checked: false,
    disabled: false,
    spacing: 'xs',
    onChange: function onChange() {
      return false;
    },
    className: "".concat(repo_config_1, "-radio"),
    theme: {}
  };

  /* xeslint-disable */

  var SelectOption = function SelectOption(props) {
    var value = props.value,
        label = props.label;
    return /*#__PURE__*/React__default['default'].createElement("div", null, value, ": ", label);
  };

  SelectOption.propTypes = {
    value: PropTypes__default['default'].any,
    label: PropTypes__default['default'].string
  };
  SelectOption.defaultProps = {
    value: undefined,
    label: ''
  };

  var commonStyles$3 = ThemeUtil.getCommonStyles();
  var StyledSelect = styled__default['default'].div(function (_ref) {
    var block = _ref.block,
        customTheme = _ref.customTheme;
    var style = {
      position: 'relative',
      display: 'inline-block'
    };

    if (block) {
      style.display = 'block';
    }

    if (customTheme.root) {
      style = cjs(style, customTheme.root);
    }

    return style;
  });
  var StyledMenuWrapper$1 = styled__default['default'].div({
    position: 'relative',
    width: '100%',
    height: 0
  });
  var StyledMenu$1 = styled__default['default'].div(function (props) {
    var customTheme = props.customTheme;
    var style = {
      position: 'absolute',
      zIndex: 10,
      top: 0,
      left: 0,
      minWidth: '100%',
      boxSizing: 'border-box',
      background: 'white',
      boxShadow: commonStyles$3.boxShadowDropdown
    };

    if (customTheme.menu) {
      style = cjs(style, customTheme.menu);
    } else {
      style = cjs(style, {
        padding: '5px',
        borderRadius: commonStyles$3.borderRadius
      });
    }

    return style;
  });

  var Select = function Select(props) {
    var layout = props.layout,
        label = props.label,
        value = props.value,
        block = props.block,
        iconOpen = props.iconOpen,
        iconClose = props.iconClose,
        disabled = props.disabled,
        children = props.children,
        onSelect = props.onSelect,
        className = props.className,
        theme = props.theme;

    var _useState = React.useState(label),
        _useState2 = _slicedToArray(_useState, 2),
        valueLocal = _useState2[0],
        setValueLocal = _useState2[1];

    var _useState3 = React.useState(label),
        _useState4 = _slicedToArray(_useState3, 2),
        labelLocal = _useState4[0],
        setLabelLocal = _useState4[1];

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isOpen = _useState6[0],
        setIsOpen = _useState6[1];

    var refComponent = React.useRef();
    var aChildren = React__default['default'].Children.toArray(children);
    /**
     * close dropdown on click outside
     */

    var handleOnClickDocument = function handleOnClickDocument(e) {
      if (!refComponent.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    /**
     * listen on document click
     * add listener on component did mount
     * remover listener on component will unmount
     */


    React.useEffect(function () {
      document.addEventListener('click', handleOnClickDocument);
      return function () {
        document.removeEventListener('click', handleOnClickDocument);
      };
    }, []);
    /**
     * update state if prop changes
     */

    React.useEffect(function () {
      setValueLocal(value);
    }, [value]);
    React.useEffect(function () {
      setLabelLocal(label);
    }, [label]);
    /**
     * handler
     */

    var handleOnClickButton = function handleOnClickButton() {
      setIsOpen(!isOpen);
    };

    var handleOnClickOption = function handleOnClickOption(optionValue, optionLabel) {
      setIsOpen(false);
      setValueLocal(optionValue);
      setLabelLocal(optionLabel);
      onSelect(optionValue, optionLabel);
    };
    /**
     * icons
     */


    var _iconOpen = iconOpen || ChevronDown;

    var _iconClose = iconClose || ChevronUp;

    return /*#__PURE__*/React__default['default'].createElement(StyledSelect, {
      ref: refComponent,
      className: className,
      block: block,
      customTheme: theme
    }, /*#__PURE__*/React__default['default'].createElement(Button, {
      layout: layout,
      label: labelLocal,
      iconRight: isOpen ? _iconClose : _iconOpen,
      onClick: handleOnClickButton,
      block: block,
      justify: "space-between",
      disabled: disabled,
      className: "".concat(className, "__button"),
      theme: {
        root: theme.button
      }
    }), isOpen && /*#__PURE__*/React__default['default'].createElement(StyledMenuWrapper$1, null, /*#__PURE__*/React__default['default'].createElement(StyledMenu$1, {
      className: "".concat(className, "__menu"),
      customTheme: theme
    }, aChildren.map(function (child, i) {
      var selected = child.props.value === valueLocal;
      return /*#__PURE__*/React__default['default'].createElement(Button, {
        key: String(i),
        layout: "option",
        label: child.props.label,
        block: true,
        justify: "flex-start",
        active: selected,
        onClick: function onClick() {
          return handleOnClickOption(child.props.value, child.props.label);
        },
        className: "".concat(className, "__option"),
        theme: {
          root: theme.option
        }
      });
    }))));
  };

  Select.propTypes = {
    /**
     * 'default', 'primary', 'secondary', 'outlined', ''
     */
    layout: PropTypes__default['default'].string,
    label: PropTypes__default['default'].string,
    value: PropTypes__default['default'].any,
    block: PropTypes__default['default'].bool,
    iconOpen: PropTypes__default['default'].any,
    iconClose: PropTypes__default['default'].any,
    disabled: PropTypes__default['default'].bool,

    /**
     * SelectOption | [any component that supports value and label]
     */
    children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].instanceOf(SelectOption), PropTypes__default['default'].node]),
    onSelect: PropTypes__default['default'].func,
    className: PropTypes__default['default'].string,
    theme: PropTypes__default['default'].object
  };
  Select.defaultProps = {
    layout: '',
    label: '',
    value: undefined,
    block: false,
    iconOpen: null,
    iconClose: null,
    disabled: false,
    children: null,
    onSelect: function onSelect() {},
    className: "".concat(repo_config_1, "-select"),
    theme: {}
  };

  var colors$5 = ThemeUtil.getColors();
  var StyledSwitch = styled__default['default'].button(function (_ref) {
    var customTheme = _ref.customTheme;
    var style = {
      appearance: 'none',
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      padding: 0,
      border: 0,
      background: 'transparent',
      position: 'relative',
      cursor: 'pointer',
      '&[data-disabled]': {
        opacity: 0.5,
        cursor: 'default',
        pointerEvents: 'none'
      }
    };

    if (customTheme.root) {
      style = cjs(style, customTheme.root);
    } else {
      style = cjs(style, {
        '&:focus': {
          outline: 0
        }
      });
    }

    return style;
  });
  var StyledTrack = styled__default['default'].div(function (_ref2) {
    var customTheme = _ref2.customTheme;
    var style = {
      display: 'inline-block',
      width: '40px',
      height: '20px',
      background: colors$5.grey,
      borderRadius: '10px'
    };

    if (customTheme.track) {
      style = cjs(style, customTheme.track);
    } else {
      style = cjs(style, {
        '&[data-focus]': {
          background: colors$5.dark
        },
        '&[data-hover]': {
          background: colors$5.grey
        }
      });
    }

    return style;
  });
  var StyledThumb = styled__default['default'].div(function (_ref3) {
    var customTheme = _ref3.customTheme;
    var style = {
      display: 'inline-block',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '20px',
      height: '20px',
      borderRadius: '10px',
      background: colors$5.greyText,
      transition: 'left 0.2s ease',
      '&[data-checked]': {
        left: '20px',
        background: colors$5.primary
      }
    };

    if (customTheme.thumb) {
      style = cjs(style, customTheme.thumb);
    }

    return style;
  });

  var Switch = function Switch(props) {
    var checked = props.checked,
        disabled = props.disabled,
        ariaLabel = props.ariaLabel,
        onChange = props.onChange,
        className = props.className,
        theme = props.theme;

    var _useState = React.useState(checked),
        _useState2 = _slicedToArray(_useState, 2),
        isChecked = _useState2[0],
        setIsChecked = _useState2[1];

    var _useState3 = React.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isFocus = _useState4[0],
        setIsFocus = _useState4[1];

    var _useState5 = React.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isHover = _useState6[0],
        setIsHover = _useState6[1];

    React.useEffect(function () {
      setIsChecked(checked);
    }, [checked]);

    var handleOnClick = function handleOnClick() {
      setIsChecked(!isChecked);
      onChange(!isChecked);
    };

    var handleOnMouseLeave = function handleOnMouseLeave(e) {
      setIsHover(false);
      e.currentTarget.blur();
    };

    var classNameComponent = className;

    if (isChecked) {
      classNameComponent += " ".concat(className, "--checked");
    }

    var settings = {};

    if (ariaLabel) {
      settings['aria-label'] = ariaLabel;
    }

    var data = {};

    if (isChecked) {
      data['data-checked'] = true;
    }

    if (disabled) {
      data['data-disabled'] = true;
    }

    if (isFocus) {
      data['data-focus'] = true;
    }

    if (isHover) {
      data['data-hover'] = true;
    }

    return /*#__PURE__*/React__default['default'].createElement(StyledSwitch, _extends({
      className: classNameComponent,
      customTheme: theme,
      disabled: disabled,
      onClick: handleOnClick,
      onFocus: function onFocus() {
        return setIsFocus(true);
      },
      onBlur: function onBlur() {
        return setIsFocus(false);
      },
      onMouseEnter: function onMouseEnter() {
        return setIsHover(true);
      },
      onMouseLeave: handleOnMouseLeave
    }, settings, data), /*#__PURE__*/React__default['default'].createElement(StyledTrack, _extends({
      className: "".concat(className, "__track"),
      customTheme: theme
    }, data)), /*#__PURE__*/React__default['default'].createElement(StyledThumb, _extends({
      className: "".concat(className, "__thumb"),
      customTheme: theme
    }, data)));
  };

  Switch.propTypes = {
    checked: PropTypes__default['default'].bool,
    disabled: PropTypes__default['default'].bool,
    ariaLabel: PropTypes__default['default'].string,
    onChange: PropTypes__default['default'].func,
    className: PropTypes__default['default'].string,
    theme: PropTypes__default['default'].object
  };
  Switch.defaultProps = {
    checked: false,
    disabled: false,
    ariaLabel: '',
    onChange: function onChange() {},
    className: "".concat(repo_config_1, "-switch"),
    theme: {}
  };

  var stylesTextSmall$2 = ThemeUtil.getStylesTextSmall();
  var stylesTextMedium$4 = ThemeUtil.getStylesTextMedium();
  var StyledText = styled__default['default'].div(function (_ref) {
    var size = _ref.size,
        color = _ref.color,
        fontSize = _ref.fontSize,
        lineHeight = _ref.lineHeight,
        textAlign = _ref.textAlign;
    var style = {};

    if (size === 'small') {
      style = _objectSpread2({}, stylesTextSmall$2);
    } else {
      style = _objectSpread2({}, stylesTextMedium$4);
    }

    style = _objectSpread2(_objectSpread2({}, style), {}, {
      color: COLORS[color] || color || COLORS.DARK,
      textAlign: textAlign
    });
    /**
     * fontSize
     */

    if (fontSize) {
      style.fontSize = fontSize;
    }
    /**
     * lineHeight
     */


    if (lineHeight) {
      style.lineHeight = lineHeight;
    }

    return style;
  });

  var Text = function Text(props) {
    var className = props.className,
        children = props.children;

    var styledSettings = _objectSpread2({}, props);

    delete styledSettings.className;
    delete styledSettings.children;
    return /*#__PURE__*/React__default['default'].createElement(StyledText, _extends({}, styledSettings, {
      className: className
    }), children);
  };

  Text.propTypes = {
    size: PropTypes__default['default'].string,
    color: PropTypes__default['default'].string,
    fontSize: PropTypes__default['default'].string,
    lineHeight: PropTypes__default['default'].string,
    textAlign: PropTypes__default['default'].string,
    className: PropTypes__default['default'].string,
    children: PropTypes__default['default'].any
  };
  Text.defaultProps = {
    size: null,
    color: null,
    fontSize: null,
    lineHeight: null,
    textAlign: null,
    className: null,
    children: null
  };

  var StyledComponent$1 = styled__default['default'].div(function (props) {
    var customTheme = props.customTheme;
    var style = {
      display: 'inline-block'
    };

    if (customTheme.root) {
      style = cjs(style, customTheme.root);
    }

    return style;
  });
  var StyledInput$3 = styled__default['default'].input({
    display: 'none'
  });

  var UploadButton = function UploadButton(props) {
    var accept = props.accept,
        multiple = props.multiple,
        className = props.className,
        theme = props.theme,
        onChange = props.onChange;
    var refInputFile = React.useRef();

    var handleOnClickButton = function handleOnClickButton() {
      if (refInputFile && refInputFile.current) {
        refInputFile.current.click();
      }
    };

    var handleChangeInputFile = function handleChangeInputFile(e) {
      onChange(e);
    };

    var inputSettings = {};

    if (accept) {
      inputSettings.accept = accept;
    }

    if (multiple) {
      inputSettings.multiple = multiple;
    }

    var buttonSettings = _objectSpread2({}, props);

    delete buttonSettings.accept;
    delete buttonSettings.multiple;
    delete buttonSettings.className;
    delete buttonSettings.theme;
    return /*#__PURE__*/React__default['default'].createElement(StyledComponent$1, {
      className: className,
      customTheme: theme
    }, /*#__PURE__*/React__default['default'].createElement(StyledInput$3, _extends({
      ref: refInputFile,
      type: "file",
      onChange: handleChangeInputFile
    }, inputSettings)), /*#__PURE__*/React__default['default'].createElement(Button, _extends({
      className: "".concat(className, "__button"),
      theme: {
        root: theme.button
      },
      onClick: handleOnClickButton
    }, buttonSettings)));
  };

  UploadButton.propTypes = {
    accept: PropTypes__default['default'].string,
    multiple: PropTypes__default['default'].bool,
    className: PropTypes__default['default'].string,
    theme: PropTypes__default['default'].object,
    onChange: PropTypes__default['default'].func
  };
  UploadButton.defaultProps = {
    accept: '',
    multiple: false,
    className: "".concat(repo_config_1, "-upload-button"),
    theme: {},
    onChange: function onChange() {}
  };

  exports.Block = Block;
  exports.Button = Button;
  exports.Checkbox = Checkbox;
  exports.Collapse = Collapse;
  exports.CroppedImage = CroppedImage;
  exports.Dropdown = Dropdown;
  exports.Grid = Grid;
  exports.GridItem = GridItem;
  exports.Group = Group;
  exports.GroupItem = GroupItem;
  exports.InlineSVG = InlineSVG;
  exports.Input = Input;
  exports.Radio = Radio$1;
  exports.RadioGroup = Radio;
  exports.Select = Select;
  exports.SelectOption = SelectOption;
  exports.Switch = Switch;
  exports.Text = Text;
  exports.UploadButton = UploadButton;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
